import { ChatHeader, MessageInput, MessageList, NicknameForm } from '../components';
import { useChatMessage, useChatNode } from '../hooks';

/**
 * Main chat page component that handles the entire chat experience
 * Shows nickname form if user hasn't joined, otherwise shows chat interface
 * @returns {JSX.Element} Chat page with conditional rendering based on join status
 */
export const ChatPage = () => {
    const { node, messages, joinRoom, connectionStatus, leaveRoom, isJoining, isLeaving } = useChatNode();
    const { sendHttpMessage, isSending } = useChatMessage(node?.id, node?.roomId);

    // Show nickname form if user hasn't joined yet

    if (!node) {
        return <NicknameForm onJoin={joinRoom} isJoining={isJoining} />;
    }

    return (
        <div className="flex flex-col h-screen bg-white">
            <ChatHeader
                nickname={node.nickname || ''}
                connectionStatus={connectionStatus}
                onLeave={leaveRoom}
                isLeaving={isLeaving}
                canLeave={!!node.id}
            />

            <div className="flex-1 overflow-hidden">
                <MessageList
                    messages={messages}
                    currentUserId={node.connectionId || ''}
                    currentUserNickname={node.nickname || ''}
                />
            </div>

            <MessageInput onSendMessage={sendHttpMessage} isSending={isSending} />
        </div>
    );
};
